import gql from 'graphql-tag';

export const mutationSendAccessRequestEmail = gql`
  mutation sendAccessRequestEmail (
    $accountID: DokkioID!
    $email: String!
    $message: String
  ) {
    sendAccessRequestEmail (
      accountID: $accountID
      email: $email
      message: $message
    )
  }
`;
export default mutationSendAccessRequestEmail;
